import React from 'react';
import { PLAN_ROW_ITEM_PROP_TYPES } from './constants';
import { RowItem, RowItemCompact } from './components';

const PlanRowItem = ({
  text = null,
  isCompact = false,
  loading = false,
  contentType = 'icon-check',
}) =>
  isCompact ? (
    <RowItemCompact text={text} contentType={contentType} />
  ) : (
    <RowItem text={text} contentType={contentType} loading={loading} />
  );

PlanRowItem.propTypes = PLAN_ROW_ITEM_PROP_TYPES;

export default PlanRowItem;
